export function sendEvent(eventName, data) {
  var event = new CustomEvent(eventName, { detail: data });
  window.dispatchEvent(event);

  return true;
}
export const searchIndex = [
    'PatientName', 
    'OrderId',
    'Exam',
    'EstimatedResultDate',
    'Urgency',
    'EventStage',
    'ProductionUnitName'
 ]

export function filterPois(pois, mapId, categoryId) {
  if (pois && mapId && Object.keys(pois).length > 0 && categoryId) {
    let reducedMapId = getFloorIdByPlaceId(mapId);
    for (const index in pois) {
      const poi = pois[index];

      if (poi.categoryId != categoryId || poi.floor != reducedMapId) {
        delete pois[index];
      }
    }
    return pois;
  } else {
    return null;
  }
}

export function filterPoiByName(pois, poiName){
  if(pois && poiName && Object.keys(pois).length > 0){
    for(let index in pois){
      let poi = pois[index]
      if(poi.title === poiName){
        return poi;
      }
    }
  }
  return null;
}

export function getFloorIdByPlaceId(fullId) {
  if (!fullId || fullId.indexOf("-floor") < 0) {
    return null;
  }
  return fullId.replace(/.*-floor/g, "").replace(/_.*/g, "");
}

export function getEmbedded() {
  const isEmbedded = localStorage.getItem("embedded");
  if (isEmbedded === "true") {
    return true;
  }

  return false;
}

export function setEmbeddedFromLocalStorage(isEmbedded) {
  localStorage.setItem("embedded", isEmbedded);
}

export function transformCoordinatesToLeaflet(coords){
  let x =  coords[0];
  let y = global.imageObj.height - coords[1];
  let result = [y,x];

  if(coords.length>2){
    result.push(coords[2]);
  } else {
    result[2] = 0;
  }

  return result;
}

export function getCoordinateDirection(lngOrigin, lngDestination){
  if(lngOrigin !== null && lngDestination!== null)
  {
    if(lngOrigin <= lngDestination){
      return 'back';
    }else{
      return 'go';
    }
  }
}

function calculateCurvePointControl (pInitial, pFinal, radius, flip=false){

  if(flip){
    let auxPoint = pFinal;
    pFinal = pInitial;
    pInitial = auxPoint;
  }

  let offsetX = pFinal.x - pInitial.x,
      offsetY = pFinal.y - pInitial.y;

  let phi = Math.asin(1/(2*radius));
  let h = radius*Math.cos(phi);

  let pointerX = pInitial.x + offsetX/2 - h*(offsetY/1),
      pointerY = pInitial.y + offsetY/2 + h*(offsetX/1);

  return {x: pointerX, y: pointerY}
}

export function calculateCurvePoints(accuracy = 100, pInitial ,pFinal, radius = 0.6, flip = false){
  const tFator = 1 / accuracy;
  let t = 0;
  let pointers = [];
  let pMiddle = calculateCurvePointControl(pInitial, pFinal, radius, flip);
  pointers.push([pInitial.x, pInitial.y]);
  while (t < 0.998) {
    t += tFator;
    let bx = 2 * (pMiddle.x - pInitial.x),
        ax =  pFinal.x - pInitial.x - bx;

    let by = 2 * (pMiddle.y - pInitial.y),
        ay =  pFinal.y - pInitial.y - by;
    
    let x = (ax * t**2) + (bx * t) + pInitial.x;
    let y = (ay * t**2) + (by * t) + pInitial.y;

    pointers.push([ x, y])
  }
  pointers.push([pFinal.x, pFinal.y]);
  return pointers;
}

export function addPaddingInMap(paddings = {}){
  if(global.L){
    if(paddings){
      let paddingRightFactor = paddings.right ? paddings.right/100 : 0;
      let paddingLeftFactor = paddings.left ? paddings.left/100 : 0;
      let paddingTopFactor = paddings.top ? paddings.top/100 : 0;
      let paddingBottomFactor = paddings.bottom ? paddings.bottom/100 : 0;
      global.L.Map.prototype.getSize = function getSize() {
        if (!this._size || this._sizeChanged) {
          this._size = new global.L.Point(
            this._container.clientWidth + (this._container.clientWidth * (paddingLeftFactor - paddingRightFactor)) || 0,
            this._container.clientHeight + (this._container.clientHeight * (paddingTopFactor - paddingBottomFactor)) || 0);
    
          this._sizeChanged = false;
        }
        return this._size.clone();
      }
    }
  }
}

export function normalizeJSON(json){
  let jsonString = JSON.stringify(json);
  let correctJson = jsonString.replace(/(\\r\\n|\\n|\\r|\\t|\\)/g, "");
  try {
      return JSON.parse(correctJson);
  } catch (error) {
      correctJson = correctJson.substring(1, correctJson.length - 1);
      return JSON.parse(correctJson);
  }
}

export function parseDate(date){
  if(!date) {
    return null;
  }
  let parsedDate = new Date();
  let tempDate = date.split(' ');
  let year = tempDate[0].split('-')[0];
  let month = tempDate[0].split('-')[1];
  let day = tempDate[0].split('-')[2];
  let hour = tempDate[1].split(':')[0];
  let minutes = tempDate[1].split(':')[1];
  let seconds = tempDate[1].split(':')[2];
  parsedDate.setYear(parseInt(year));
  parsedDate.setMonth(parseInt(month));
  parsedDate.setDate(parseInt(day));
  parsedDate.setHours(parseInt(hour));
  parsedDate.setMinutes(parseInt(minutes));
  parsedDate.setSeconds(parseInt(seconds));
  
  return parsedDate.getTime();
}

export function isAlphanumericOrderId(value){
  if(value && value.length && value.length === 7){
    let regexp = new RegExp(/^(?=.*?\d)(?=.*?[a-zA-Z])[a-zA-Z\d]+$/);
    let isValidAlphanumereciOrderId = regexp.test(value);

    return isValidAlphanumereciOrderId;
  } else {
    return null;
  }
}